import { RecoveryCodes, ConfirmMfa } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { snackbarService } from '/common/snackbarService';

import { userProfileKey } from './useUpdateProfile';

const confirmResetMfaCodesKey = userProfileKey.concat('requestMFA');

export const useConfirmResetMFACodes = (
  options?: UseMutationOptionsExtended<RecoveryCodes | undefined, GenericFailure | Error, ConfirmMfa>
) =>
  useEitherMutation((mfa) => services2.userProfileService.confirmCodesReset(mfa), {
    mutationKey: confirmResetMfaCodesKey,
    onError: (err) => {
      snackbarService.error('Could not reset recovery codes. Message: ', err.message);
    },
    ...options,
  });
